import api from "./api";

const universityService = {
  list: (params) => api.get("/universities", { params }).then((r) => r.data),
  get: (id) => api.get(`/universities/${id}`).then((r) => r.data),
  create: (payload) => api.post("/universities", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/universities/${id}`, payload).then((r) => r.data),
  setStatus: (id, is_active) =>
    api.patch(`/universities/${id}/status`, { is_active }).then((r) => r.data),
  publicActive: () => api.get("/universities/public/active").then((r) => r.data),
};

export default universityService;
